//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentDelivery', {
//        templateUrl: 'views/components/views/consignmentDelivery/consignmentDelivery.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'consignmentDeliveryService', 'rememberService', 'ieScreenBlockService', function (stateService, utilityService, consignmentDeliveryService, rememberService, ieScreenBlockService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                deliverymethod_no: ''
//            };

//            vm.model = {
//                bgConsignmentDelivery: {
//                    selected: 'active',
//                    buttons: [
//                        { id: 'active', label: 'active', color: 'primary', onClick: () => vm.model.bgConsignmentDelivery.selected = 'active' },
//                        { id: 'delivered', label: 'delivered', color: 'primary', onClick: () => vm.model.bgConsignmentDelivery.selected = 'delivered' }
//                    ]
//                },
//                setting: {},
//                selectListDeliveryMethods: [],
//                itemsListConsignmentDeliveries: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await consignmentDeliveryService.getSetting())[0];
                
//                if (parseInt(vm.model.setting.active_deliverymethod_no) > 0) {
//                    vm.model.setting.deliverymethod_no = vm.model.setting.active_deliverymethod_no;
//                } else {
//                    vm.model.setting.active_deliverymethod_no = 0;
//                }
//            }

//            async function loadDeliveryMethods() {
//                vm.model.selectListDeliveryMethods = await consignmentDeliveryService.listDeliveryMethods();
//            }

//            async function loadConsignmentDeliveries() {
//                if (utilityService.validateParmsValue(vm.model.setting.deliverymethod_no) !== true) return;

//                if (vm.model.setting.deliverymethod_no > 0) {
//                    ieScreenBlockService.start('message');
//                    ieScreenBlockService.setMessage('Laster informasjon');

//                    return consignmentDeliveryService.listConsignmentDeliveries({
//                        deliverymethod_no: vm.model.setting.deliverymethod_no,
//                        list_type: vm.model.bgConsignmentDelivery.selected
//                    }).then(function (list) {
//                        ieScreenBlockService.stop();
//                        vm.model.itemsListConsignmentDeliveries = list;
//                    });
//                }
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case 'deliverymethod_no':
//                            variableNames[key] = 'cd_deliverymethod_no';
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'deliverymethod_no':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgConsignmentDelivery = function (value) {
//                vm.model.bgConsignmentDelivery.selected = value;

//                loadConsignmentDeliveries();
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = async function (value, id) {
//                switch (id) {
//                    case 'deliverymethod_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.deliverymethod_no) !== true) return;

//                        vm.model.setting.deliverymethod_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.deliverymethod_no) !== true) return;

//                        rememberFunc('deliverymethod_no');
//                        await loadConsignmentDeliveries();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadDeliveryMethods();

//                if (vm.model.selectListDeliveryMethods.length > 0) loadConsignmentDeliveries();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
